import React from "react";
import styles from "./embeded.module.scss";
import Loader from "../../components/Loader/Loader";
import Button, { BTN_VARIANTS } from "../../components/Button";
const embedConstants = [
  {
    title: (
      <span className={styles.title}>
        Explore the <span className="blue-text">Sentinel</span> Network
      </span>
    ),
    link: "https://map.sentinel.co/",
    button: {
      title: "Node Map",
      href: "https://map.sentinel.co/",
    },
  },
  {
    title: (
      <span className={styles.title}>
        Discover <span className="blue-text">Nodes</span>
      </span>
    ),
    link: "https://nodes.sentinel.co/",
    button: {
      title: "Discover Nodes",
      href: "https://nodes.sentinel.co/",
    },
  },
];

const IFrame = ({ em }) => {
  const [showLoader, setShowLoader] = React.useState(true);
  return (
    <>
      {showLoader && (
        <section className={styles.loader}>
          <Loader />
        </section>
      )}

      <iframe
        src={em.link}
        title={em.title}
        onLoad={() => setShowLoader(false)}
      />
    </>
  );
};

const Embeds = () => {
  return (
    <div className={styles.root}>
      {embedConstants.map((em) => {
        return (
          <section key={em.link} className={styles.embeded}>
            {em.title}
            <IFrame em={em} />
            <Button
              className={styles.btn}
              variant={BTN_VARIANTS.primary}
              onClick={() => window.open(em.button.href)}
            >
              <span>{em.button.title}</span>
            </Button>
          </section>
        );
      })}
    </div>
  );
};

export default Embeds;
